import styled from 'styled-components'
// import {
//   useCustomEvent,
//   useEmitter,
//   useListener,
// } from 'react-custom-events-hooks'
import { useEffect, useRef } from 'react'
import { ContentWidth } from '@ta-interaktiv/react-disco-grid'

const bg = require('../../assets/sky.jpg')

export const Header = ({
  colorMode,
  tenant,
}: {
  colorMode: 'light' | 'dark' | undefined
  tenant: Tenant | undefined
}) => {
  const chapteref = useRef<HTMLDivElement>(null)
  // const sendChaptersChangedMessage = useCustomEvent({
  //   eventName: 'chaptersChanged',
  // })
  // useEffect(() => {
  //   if (!chapteref.current) return
  //   let w = window as any
  //   if (!w.MFDATA) w.MFDATA = {}
  //   if (!w.MFDATA.chapters) w.MFDATA.chapters = {}
  //   w.MFDATA.chapters['header'] = chapteref.current

  //   sendChaptersChangedMessage({})
  // }, [chapteref.current])

  return (
    <ContentWidth>
      <HeaderRoot ref={chapteref}>
        <ImageContainer>
          <img
            src={require('../../assets/header_auswertung' +
              (colorMode === 'dark' ? '_dm' : '') +
              '.jpg')}
          />
          <Title>
            <div className='schlaf'>
              Jede dritte Frau ab 50 hat Schlaf&shy;probleme
            </div>
          </Title>
        
          <Spacer />
        </ImageContainer>
        <Authors colorMode={colorMode}>
          <span key={83371228}>
            <a
              href={
                tenant && tenant.key
                  ? `https://www.${
                      tenant.key
                    }.ch/author/${83371228}/marc-brupbacher`
                  : ''
              }
              style={{ background: 'none' }}
            >
              Marc Brupbacher
            </a>
          </span>
          <span key={84880321}>
            <a
              href={
                tenant && tenant.key
                  ? `https://www.${
                      tenant.key
                    }.ch/author/${84880321}/sebastian-broschinski`
                  : ''
              }
              style={{ background: 'none' }}
            >
              Sebastian Broschinski
            </a>
          </span>
        </Authors>
        <Publication
          colorMode={colorMode}
          onClick={() => {
            localStorage.removeItem('schlafumfrageUserID')
            localStorage.removeItem('schlafumfrage')
            localStorage.removeItem('schlafumfrageUserID_Send')
          }}
        >
          Publiziert am 25. Mai 2023
        </Publication>
      </HeaderRoot>
    </ContentWidth>
  )
}
const Publication = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  font-size: 12px;
  color: var(--gray-3);
  font-family: var(--font-sans-serif);
  margin-bottom: 60px;
  margin-top: 20px;
  flex: 0 0 100%;
  text-align: center;
`
const Authors = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  width: 100%;
  text-align: center;

  color: var(--text-color);
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  line-height: 1.8rem;
  max-width: 80%;
  /* border-top: ${({ colorMode }) =>
    colorMode === 'dark'
      ? '1px solid var(--gray-2)'
      : '1px solid var(--gray-4)'}; */
  padding-top: 2rem;

  button {
    &:hover {
      cursor: pointer;
    }
    padding: 0;
    border: 0;
    background-color: transparent;
  }
  a,
  button {
    color: var(--text-color);
    text-decoration: none;
    border-bottom: 1px solid var(--text-color);
  }
  span {
    white-space: nowrap;
  }
  span::after {
    content: ', ';
  }
  span:last-child::after {
    content: '';
  }
`
const HeaderRoot = styled.div.attrs({ className: 'header' })`
  line-height: 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 100vw;

  @media screen and (max-width: 711px) {
    margin-bottom: 60px;
  }
`
const Spacer = styled.div`
  display: inline-block;
  width: 100%;
  height: 180px;
  background-color: var(--site-background);
  margin-top: -1px;
  margin-bottom: -1px;
  @media screen and (max-width: 1023px) {
    height: 250px;
  }
  @media screen and (max-width: 850px) {
    height: 250px;
  }
  @media screen and (max-width: 800px) {
    height: 150px;
  }
  @media screen and (max-width: 755px) {
    height: 150px;
  }
  @media screen and (max-width: 641px) {
    height: 200px;
  }
  @media screen and (max-width: 550px) {
    height: 100px;
  }
  @media screen and (max-width: 513px) {
    height: 110px;
  }
  @media screen and (max-width: 460px) {
    height: 150px;
  }
  @media screen and (max-width: 350px) {
    height: 200px;
  }
`
const ImageContainer = styled.div`
  background-image: url(${bg});
  background-attachment: fixed;
  position: relative;
  img {
    width: 100%;
    max-width: 1100px;
  }
  @media screen and (max-width: 711px) {
    margin-bottom: 0px;
    img {
      max-width: 150vw;

      margin-left: 0;
    }
  }
`
const Title = styled.h1`
  color: var(--text-color);
  font-family: var(--font-sans-serif);
  font-weight: 300;
  position: absolute;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  left: 50%;
  /* bottom: -12%; */
  line-height: 1.3em;
  width: 100%;

  transform: translateX(-50%);
  /* 
  @media screen and (max-width: 711px) {
    bottom: -20%;
  }
  @media screen and (max-width: 500px) {
    bottom: -50%;
    width: 80%;
  } */
  .fragen {
    font-size: 50px;
    flex: 0 0 100%;
    text-align: center;
    line-height: 100px;
    @media screen and (max-width: 850px) {
      font-size: 36px;
      line-height: 70px;
    }
    @media screen and (max-width: 550px) {
      font-size: 36px;
      color: var(--text-color);
    }
  }
  .schlaf {
    font-family: 'Suez One', serif;
    text-transform: uppercase;
    font-size: 65px;
    line-height: 1.2em;
    flex: 0 0 100%;
    text-align: center;

    @media screen and (max-width: 800px) {
      font-size: 50px;
    }
    @media screen and (max-width: 550px) {
      font-size: 36px;
      color: var(--text-color);
    }
  }
`
const Lead = styled.h2`
font-size: 18px;

`